export default __webpack_public_path__ + "static/media/login-hero@3x.beca7242.png";